var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#227EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.191 14C31.28 14 33 15.78 33 18.83V29.16C33 32.26 31.28 34 28.191 34H19.81C16.77 34 15 32.26 15 29.16V18.83C15 15.78 16.77 14 19.81 14H28.191ZM20.08 27.74C19.78 27.71 19.49 27.85 19.33 28.11C19.17 28.36 19.17 28.69 19.33 28.95C19.49 29.2 19.78 29.35 20.08 29.31H27.92C28.319 29.27 28.62 28.929 28.62 28.53C28.62 28.12 28.319 27.78 27.92 27.74H20.08ZM27.92 23.179H20.08C19.649 23.179 19.3 23.53 19.3 23.96C19.3 24.39 19.649 24.74 20.08 24.74H27.92C28.35 24.74 28.7 24.39 28.7 23.96C28.7 23.53 28.35 23.179 27.92 23.179ZM23.069 18.65H20.08V18.66C19.649 18.66 19.3 19.01 19.3 19.44C19.3 19.87 19.649 20.22 20.08 20.22H23.069C23.5 20.22 23.85 19.87 23.85 19.429C23.85 19 23.5 18.65 23.069 18.65Z",
    fill: "#E9F2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.01c75037d36d5b04fe683d9602d5cc6f.svg";
export { ForwardRef as ReactComponent };